import { useNavigate } from '@tanstack/react-router';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Text } from '../../../cdl/Text/Text';
import { NavigationLinkProps } from '../../Link/NavigationLink';
import { theme } from '../../ui/theme';

import { sidebarMenuItemStyles } from './sidebarMenuItemStyles';

const StyledSidebarMenuButton = styled.button`
    ${sidebarMenuItemStyles};
    text-decoration: none;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    cursor: pointer;

    &:visited {
        color: ${theme.colors.foreground.default};
        background-color: ${theme.colors.background.inset};
        text-decoration: none;
    }
`;

interface SidebarMenuNavigationItemProps extends Omit<NavigationLinkProps, 'children'> {
    children: ReactNode;
    closeMenu: () => void;
}

export const SidebarMenuNavigationItem = ({ children, closeMenu, ...linkProps }: SidebarMenuNavigationItemProps) => {
    const navigate = useNavigate();

    const ANIMATION_DURATION_MS = 300;

    const handleClick = (e: React.MouseEvent) => {
        if (closeMenu) {
            e.preventDefault();
            closeMenu();
            // Navigate after animation completes (~300ms based on spring config)
            setTimeout(() => {
                navigate({ to: linkProps.to });
            }, ANIMATION_DURATION_MS);
        }
    };

    return (
        <StyledSidebarMenuButton onClick={handleClick}>
            <Text variant="fieldLabel">{children}</Text>
        </StyledSidebarMenuButton>
    );
};
